<template>
    <el-divider content-position="left"><slot></slot></el-divider>
</template>

<script>
    export default {
        name: "AttributeTitle"
    }
</script>
